import { Landmark, Users, Heart, TrendingUp } from "lucide-react";
import Reveal from "../components/Reveal";

const VALUES = [
  { icon: Heart, title: "Passione", text: "Il calcio come amore assoluto: ogni allenamento, ogni partita, ogni gol." },
  { icon: Users, title: "Comunità", text: "Una famiglia nero-gialla che cresce insieme, dentro e fuori dal campo." },
  { icon: TrendingUp, title: "Crescita", text: "Dalla seconda squadra CSI alla prima FIGC: il futuro si costruisce ogni giorno." },
  { icon: Landmark, title: "Territorio", text: "Radicati nel quartiere, orgogliosi di rappresentarlo in ogni campionato." },
];

const TIMELINE = [
  ["2024", "Fondazione", "Nasce l'Artemide Football Club: il cervo diventa il simbolo del club."],
  ["2025", "Nasce la squadra CSI", "Il progetto giovani prende forma con la Seconda Squadra iscritta al campionato di calcio a 7 CSI."],
  ["2026", "Prima promozione", "La Prima Squadra conquista la Seconda Categoria FIGC dopo una stagione memorabile."],
];

export default function ChiSiamo() {
  return (
    <main data-testid="chi-siamo-page">
      <section className="relative py-24 sm:py-32 overflow-hidden">
        <div className="absolute left-0 top-0 h-full w-3 diagonal-stripes opacity-90" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <h1 className="font-display font-black uppercase text-6xl sm:text-8xl lg:text-9xl text-white leading-[0.85] tracking-[0.02em]" data-testid="chi-siamo-title">
            Chi <span className="text-gold">Siamo</span>
          </h1>
          <p className="mt-8 max-w-3xl text-zinc-300 text-lg sm:text-xl leading-relaxed">
            Un nome che nasce dalla storia, una squadra che guarda al futuro.
            <span className="text-gold font-semibold"> Sempre a caccia del prossimo traguardo.</span>
          </p>
          <Reveal className="mt-14 max-w-4xl" data-testid="chi-siamo-manifesto">
            <div className="relative grey-fade border border-line border-l-4 border-l-gold p-8 sm:p-12 overflow-hidden">
              <span className="absolute -top-8 -left-1 font-display font-black text-[9rem] leading-none text-stroke-gold opacity-40 select-none" aria-hidden="true">"</span>
              <p className="font-mono text-xs tracking-[0.3em] uppercase text-gold mb-5">Perché Esistiamo</p>
              <p className="relative font-display font-semibold uppercase text-2xl sm:text-3xl lg:text-4xl leading-snug text-white">
                L'idea nasce da un gruppo di ragazzi che, notando sempre di più l'elevato numero di giovani
                calciatori che lasciavano il mondo sportivo per motivi economici, organizzativi e per semplice
                perdita di motivazione, ha cercato un modo per creare una realtà
                <span className="bg-gold text-night px-2 mx-1 inline-block">gratuita</span>
                che li convincesse a non smettere di divertirsi.
              </p>
            </div>
          </Reveal>
        </div>
      </section>

      <Reveal className="max-w-7xl mx-auto px-4 sm:px-6" data-testid="chi-siamo-values">
        <h2 className="font-display font-black uppercase text-4xl sm:text-6xl text-white leading-none mb-10">
          I Nostri <span className="text-gold">Valori</span>
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {VALUES.map((v, i) => (
            <div key={v.title} className="relative grey-fade border border-line border-l-4 border-l-gold p-8 overflow-hidden" data-testid={`value-card-${v.title.toLowerCase()}`}>
              <span className="absolute top-3 right-4 font-display font-black text-6xl leading-none text-stroke-gold opacity-60">0{i + 1}</span>
              <v.icon className="text-gold mb-4" size={32} />
              <h3 className="font-display font-bold uppercase text-3xl text-white">{v.title}</h3>
              <p className="text-zinc-400 text-sm mt-3">{v.text}</p>
            </div>
          ))}
        </div>
      </Reveal>

      <Reveal className="max-w-7xl mx-auto px-4 sm:px-6 mt-24" data-testid="chi-siamo-timeline">
        <h2 className="font-display font-black uppercase text-4xl sm:text-6xl text-white leading-none mb-10">
          La Nostra <span className="text-gold">Storia</span>
        </h2>
        <div className="border-l-4 border-gold pl-8 space-y-10">
          {TIMELINE.map(([year, title, text]) => (
            <div key={year} className="relative" data-testid={`timeline-${year}`}>
              <span className="absolute -left-[42px] top-1 h-4 w-4 bg-gold" />
              <p className="font-display font-black text-5xl sm:text-6xl text-stroke-gold leading-none">{year}</p>
              <h3 className="font-display font-bold uppercase text-2xl sm:text-3xl text-white mt-1">{title}</h3>
              <p className="text-zinc-400 mt-2 max-w-2xl">{text}</p>
            </div>
          ))}
        </div>
      </Reveal>

    </main>
  );
}
